import React, { useEffect, useState } from "react";
import Board, { moveCard } from "@asseinfo/react-kanban";
import "@asseinfo/react-kanban/dist/styles.css";
import MainHeader from "../../components/MainHeader";
import api from "../../services/api";
import Card from "./Card";
import {
	Button,
	ClickAwayListener,
	TextField,
	Typography,
	makeStyles,
} from "@material-ui/core";
import toastError from "../../errors/toastError";
import ColorPicker from "../../components/ColorPicker";
import "../../css/pages/SalesFunnel/kanban.css";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
		const useStyles = makeStyles((theme) => ({
			columnHeader: {
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					position: "relative"
			},
				columnTitle: {
					display: "flex",
					alignItems: "center",
					flexDirection: "column"
			},
				cardsCounter: {
			},
				addCard: {
					fontSize: 12,
					width: "100%",
					border: "1px solid #ccc",
					opacity: 0.5,
					marginBottom: 5,
						"&:hover": {
							opacity: 0.8,
					},
			},
				addColumn: {
					marginTop: 5,
					fontSize: 12,
					minWidth: "250px",
					border: "1px solid #ccc",
					opacity: 0.5,
						"&:hover": {
							opacity: 0.8,
					},
			},
				addColumnInput: {
					marginTop: 5,
					minWidth: "250px",
			},
				classHeader: {
					backgroundColor: "white !important"
			},
				moreIcon: {
					opacity: 0.5,
					cursor: "pointer",
						"&:hover": {
							color: "#FD1C74",
							opacity: 0.8,
					},
			},
				select: {
					// remove bottom border
					position: "absolute",
					top: 0,
					right: 0,
					"&:before": {
							borderBottom: "none",
					},
						// remove outline on hover
						"&:after": {
							borderBottom: "none",
					},
						opacity: 0.5,
					"&:hover": {
							color: "#FD1C74",
							opacity: 0.8,
								"&:not(.Mui-disabled):before": {
									borderBottom: "none",
							},
					},
						"& .MuiList-root": {
							backgroundColor: "#fff",
					},
			},
	}));
		const Automatize = () => {
			const classes = useStyles();
			const [board, setBoard] = useState({
					columns: [],
			});
			const [inputOpen, setInputOpen] = useState({
					open: false,
					columnId: null,
			});
			const [colorPickerModalOpen, setColorPickerModalOpen] = useState(false);
			const [, setNewColumnOpen] = useState(false);
			const [editingColumn, setEditingColumn] = useState({
					id: null,
					title: null,
			});
			const [users, setUsers] = useState([]);
				const [valores, setValores] = useState({
					totalValor: 0,
					totalContacts: 0,
			});
					useEffect(() => {
					(async () => {
							try {
									const {
											data: { users },
									} = await api.get("/users/");
									setUsers(users);
							} catch (error) {
									toastError(error);
							}
					})();
			}, []);
				const reloadBoard = async () => {
					try {
						if (!window.location.hash) return
							const { data } = await api.get("/sales-funnel/column", {
									params: {
											workspace: "contacts",
											salesFunnelId : parseInt(window.location.hash.replace('#', ''))
									},
							});
								setBoard({
									columns: data.map((column) => ({
											id: column.id,
											title: column.name,
											color: column.color,
											cards: [...column.contacts],
									})),
							});
					} catch (error) {
							console.log(error);
					}
			};
				useEffect(() => {
					(async () => {
							try {
								if (!window.location.hash) return
									const { data } = await api.get("/sales-funnel/column", {
											params: {
													workspace: "contacts",
													salesFunnelId : parseInt(window.location.hash.replace('#', ''))
											},
									});
									setBoard({
											columns: data.map((column) => ({
													id: column.id,
													title: column.name,
													color: column.color,
													cards: [...column.contacts],
													valor: column.valor
											})),
									});
										setValores({
											totalValor: data.reduce(
													(acc, column) =>
															acc +
															column.contacts.reduce(
																	(total, contact) => {
										const fc = contact.funnelContact ?? contact.FunnelContact;
										return total + (parseFloat(fc?.valor) || 0);
									},
																	0
															),
													0
											),
											totalContacts: data.reduce((acc, column) => acc + column.contacts.length, 0),
									});
										} catch (error) {
									console.log(error);
							}
					})();
			}, []);
						useEffect(() => {
					if (!board.columns.length) return;
						const totalValor = board.columns.reduce(
							(acc, column) =>
									acc +
									column.cards.reduce((sum, card) => {
										const fc = card.funnelContact ?? card.FunnelContact;
										return sum + (parseFloat(fc?.valor) || 0);
									}, 0),
							0
					);
						const totalContacts = board.columns.reduce(
							(acc, column) => acc + column.cards.length,
							0
					);
						setValores({ totalValor, totalContacts });
			}, [board]);
				const handleCardMove = async (_card, source, destination) => {
					const updatedBoard = moveCard(board, source, destination);
					setBoard(updatedBoard);
						await api.post("/sales-funnel/pin-contact", {
							contactId: _card.id,
							salesFunnelId: destination.toColumnId,
					});
			};
				const removeCard = async (contactId) => {
					setBoard({
							columns: board.columns.map((column) => ({
									...column,
									cards: column.cards.filter((card) => card.id !== contactId),
							})),
					});
			};
				const updateColumn = async ({ columnId, name, color }) => {
					try {
						if(!window.location.hash) return
							const saleFunnelid = parseInt(window.location.hash.replace('#', ''));
							await api.put(`/sales-funnel/column${columnId}`, {
									name,
									color,
									saleFunnelid
							});
								reloadBoard();
					} catch (error) {
							toastError(error);
					}
						// const updatedBoard = board.columns.map((column) => {
					//   if (column.id === columnId) {
					//     return { ...column, title: name };
					//   }
					//   return column;
					// });
					// setBoard({ columns: updatedBoard });
			};
			const handleCoumnPositionChange = async (column, source, destination) => {
				if (!window.location.hash) return
				const saleFunnelid = parseInt(window.location.hash.replace('#', ''));
				const { data } = await api.put(`/sales-funnel/column${column.id}`, {
					position: destination.toPosition,
					saleFunnelid: saleFunnelid
				});
				reloadBoard(data);
			};
				return (
					<>
							<ColorPicker
									open={colorPickerModalOpen}
									handleClose={() => setColorPickerModalOpen(false)}
									onChange={(color) => {
											updateColumn({
													columnId: editingColumn.id,
													name: editingColumn.title,
													color,
											});
											setColorPickerModalOpen(false);
									}}
							/>
							<MainHeader className={classes.classHeader}>
									<div style={{ display: "flex", justifyContent: "space-between", width: "100%", padding: "1rem 2rem" }}>
													<Typography
													color="primary"
													gutterBottom
													style={{
															fontFamily: "Helvetica",
															fontWeight: 600,
															fontSize: "22px"
													}}
											>
													FUNIL DE VENDAS
											</Typography>
												<div style={{ display: "flex", gap: 35 }}>
														<div style={{ display: "flex", gap: 5, justifyContent: "center", alignItems: "center", marginTop: 5 }}>
															<Typography style={{ opacity: "0.5" }}>
																	{valores.totalContacts}
																	{" "}
																	{
																			valores.totalContacts > 0 ? "Leads:" : "Lead:"
																	}
															</Typography>
																<Typography>
																	R$ {" "}
																	{Number(String(valores.totalValor).replace(',', '.')).toFixed(2)
																	}
																</Typography>
													</div>
													<div style={{ display: "flex", gap: 10 }}>
															<Link
																	to="/sales-funel/automatize"
															>
																	<Button style={{ opacity: 1, background: "white", color: "black", minWidth: 150, fontSize: "0.8rem", fontWeight: "bolder" }}
																			className={classes.addColumn}>
																			Automatize
																	</Button>
																</Link>
															<Button
																	style={{ opacity: 1, background: "#007dff", fontSize: "0.8rem", fontWeight: "bolder", minWidth: 200, }}
																	className={classes.addColumn}
																	onClick={() => setNewColumnOpen(true)}
															>
																	Adicionar coluna
															</Button>
													</div>
												</div>
										</div>
							</MainHeader>
							<Board
									allowAddColumn
									onCardDragEnd={handleCardMove}
									onColumnDragEnd={handleCoumnPositionChange}
									renderCard={(card) => (
											<Card
													contact={card}
													removeCard={removeCard}
													users={users}
													reloadBoard={reloadBoard}
											/>
									)}
									renderColumnHeader={({ title, id, color }) => (
											<div>
													<div className={classes.columnHeader}>
															<div className={classes.columnTitle}>
																	{editingColumn.id === id ? (
																			<ClickAwayListener
																					onClickAway={() =>
																							setEditingColumn({ id: null, title: null })
																					}
																			>
																					<TextField
																							autoFocus
																							size="small"
																							label="Nome da coluna"
																							variant="outlined"
																							value={editingColumn.title}
																							onChange={(e) =>
																									setEditingColumn({
																											id: editingColumn.id,
																											title: e.target.value,
																									})
																							}
																							onKeyDown={(e) => {
																									if (e.key === "Enter") {
																											updateColumn({
																													columnId: editingColumn.id,
																													name: editingColumn.title,
																											});
																											setEditingColumn({ id: null, title: null });
																									}
																							}}
																					/>
																			</ClickAwayListener>
																	) : (
																				<Typography
																					cursor="pointer"
																					onClick={() => setEditingColumn({ id, title })}
																					className="titleColumnsKanban"
																					style={{
																							color: color || "#1f1f1f",
																							textTransform: "uppercase"
																					}}
																			>
																					{title}
																			</Typography>
																	)}
																		</div>
														</div>
													<div style={{
															width: "100%", height: 4, borderRadius: 20,
															background: color || "#1f1f1f", marginBottom: 15
													}}></div>
													{inputOpen.open &&
															inputOpen.columnId ===
															board.columns.find((column) => column.title === title).id ? (
																<ClickAwayListener
																	onClickAway={() =>
																			setInputOpen({ open: false, columnId: null })
																	}
															>
																	</ClickAwayListener>
													) : (
															<Button
																	className={classes.addCard}
																	onClick={() =>
																			setInputOpen({
																					open: true,
																					columnId: board.columns.find(
																							(column) => column.title === title
																					).id,
																			})
																	}
															>
																	Adicionar automação
															</Button>
													)}
											</div>
									)}
							>
									{board}
							</Board>
					</>
			);
	};
		export default Automatize;
